export default __webpack_public_path__ + "static/summer_containers71-b45f9f29318e067cd1e088c8fb4e3bd4.webp";